import { useQuery } from 'react-query';
import { fetchThreadDetails } from '../apiCalls';
import { QueryKey } from './QueryKeys';

const useFetchThreadsDetails = (enabled) => {
	const { data, isLoading } = useQuery(
		QueryKey.GET_THREADS_DETAILS,
		fetchThreadDetails,
		{enabled}
	);
	
	return {
		isError: data?.name === 'AxiosError',
		data: data?.name === 'AxiosError' ? null : data,
		isLoading
	};

};

export default useFetchThreadsDetails;

